﻿(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.CampaignMedia = {};

    const videoStatus = {
        loading: "loading",
        processing: "processing",
        videoCustom: "video-custom",
        videoDefault: "video-default",
        missing: "missing-video",
        error: "error"
    }
    const processingChecks = [];

    function deleteVideo(videoId) {
        const videoFile = document.getElementById(videoId);
        const deleteUrl = videoFile.dataset.deleteVideoUrl;
        const playerId = videoFile.dataset.videoPlayerId;
        const $storeFrontVideoCheck = $("#set-storefront-video");
        const token = $(videoFile).closest("form").find("input[name='__RequestVerificationToken']").val();

        if (!confirm(M2.CampaignMedia.config.confirmVideoDeleteTXT)) {
            return false;
        } else {
            if ($storeFrontVideoCheck.attr('checked') === "checked") {
                $storeFrontVideoCheck.prop('checked', false);
                clearInterval(processingChecks[videoId]);
            }
            M2.CampaignMedia.saveVideoStorefrontStatus();
            M2.Modal.resizeParentIframe();
        }

        $.ajax({
            url: deleteUrl,
            method: "POST",
            dataType: "json",
            data: {
                '__RequestVerificationToken': token
            },
            success: function (data, textStatus) {
                if (data.success === true) {
                    clearInterval(processingChecks[videoId]);
                    updateVideoDisplay(videoId, videoStatus.videoDefault, data.video);
                }
                window.parent.M2.Dashboard.refreshToDoList();
                window.parent.M2.Modal.resizeModal();
            },
            error: function (jqXHR, textStatus, errorMessage) {
                //console.log("error: " + errorMessage); // Optional
            }
        });
    }

    // Video Instructions
    function setInstructions() {
        $(document).on("click", ".open-instructions", function (e) {
            e.preventDefault();
            const $instructions = $('#instructions-container');
            $instructions.slideDown(function () {
                M2.Modal.resizeParentIframe();
            });  
        });

        $(document).on("click", ".close-instructions", function (e) {
            e.preventDefault();
            const $instructions = $('#instructions-container');
            $instructions.slideUp(function () {
                M2.Modal.resizeParentIframe();
            });
            $("html, body").animate({ scrollTop: 0 }, "fast");
        });
    }

    function setVideoUploadTools() {
        const $videoFiles = $('.video-file');

        $videoFiles.each(function () {
            const $videoFile = $(this);
            const videoId = $videoFile.attr('id');
            const videoPlayerId = $videoFile.data('video-player-id');
            const updateVideoUrl = $videoFile.data('update-video-url');
            const $uploadBtn = $("#" + $videoFile.data('upload-btn-id'));
            const $deleteBtn = $("#" + $videoFile.data('delete-btn-id'));
            const token = $videoFile.closest("form").find("input[name='__RequestVerificationToken']").val();
            const params = {
                "__RequestVerificationToken": token
            }

            $videoFile.change(function () {
                const file_data = $videoFile.prop("files")[0];
                const fileSize = file_data.size;
                const fileType = file_data.type;
                const isValidFileType = M2.Video.isValidFileType(fileType);

                if (!isValidFileType.status) {
                    alert(isValidFileType.error);
                    $videoFile.val('');
                    return false;
                }
                const isValidSize = M2.Video.isValidFileSize(fileSize);
                if (!isValidSize.status) {
                    alert(isValidSize.error);
                    $videoFile.val('');
                    return false;
                }
                $uploadBtn.removeClass('disabled');
            });

            $deleteBtn.click(function (e) {
                e.preventDefault();
                deleteVideo(videoId);
            });

            $uploadBtn.click(function (e) {
                e.preventDefault();
                if ($(this).hasClass('disabled')) {
                    return false;
                }
                
                updateVideoDisplay(videoId, videoStatus.loading);
                
                
                M2.Video.upload(videoPlayerId, $uploadBtn, $videoFile, updateVideoUrl, function () {
                    updateVideoDisplay(videoId, videoStatus.processing);
                    window.setTimeout(function (e) {
                        // Start checking on the processing status
                        M2.CampaignMedia.startVideoProcessingCheck(videoId);
                    }, 3000);
                }, params);
            });
        });
    }

    function setConfigOptions() {
        // Set config options
        /* global M2_CampaignMedia_description, M2_CampaignMedia_confirmPhotoDeleteTXT, M2_CampaignMedia_confirmVideoDeleteTXT, M2_CampaignMedia_errorSavingImageText, M2_CampaignMedia_noFileChosenText, M2_CampaignMedia_chooseFileText */
        if ('undefined' !== typeof M2_CampaignMedia_description) M2.CampaignMedia.config.description = M2_CampaignMedia_description;
        if ('undefined' !== typeof M2_CampaignMedia_confirmPhotoDeleteTXT) M2.CampaignMedia.config.confirmPhotoDeleteTXT = M2_CampaignMedia_confirmPhotoDeleteTXT;
        if ('undefined' !== typeof M2_CampaignMedia_confirmVideoDeleteTXT) M2.CampaignMedia.config.confirmVideoDeleteTXT = M2_CampaignMedia_confirmVideoDeleteTXT;
        if ('undefined' !== typeof M2_CampaignMedia_noFileChosenText) M2.CampaignMedia.config.noFileChosenText = M2_CampaignMedia_noFileChosenText;
        if ('undefined' !== typeof M2_CampaignMedia_chooseFileText) M2.CampaignMedia.config.chooseFileText = M2_CampaignMedia_chooseFileText;
    }

    function updateVideoDisplay(videoId, status, media_id) {
        media_id = media_id || "";
        const player_id = document.getElementById(videoId).dataset.videoPlayerId;
        const $videoUploadComponent = $("#" + videoId).closest(".video-upload-component");
        $videoUploadComponent.attr("data-view-mode", status);

        switch (status) {
            case videoStatus.videoCustom:
            case videoStatus.videoDefault:
                if (M2.Video.getPlayer(player_id)) M2.Video.updatePlayer(player_id, media_id);
                else M2.Video.setPlayer(player_id, media_id, M2.Util.config.theme);
                window.parent.M2.Dashboard.refreshToDoList();
                break;
        }
        if (window.location !== window.parent.location) M2.Modal.resizeParentIframe(100);
    }

    function checkVideoProcess(videoId) {
        const uploader = document.getElementById(videoId);
        const processingStatusUrl = uploader.dataset.statusCheckUrl;
        const intervalProcess = processingChecks[videoId];
        const playerId = uploader.dataset.videoPlayerId;

        M2.Video.getProcessingStatus(processingStatusUrl).done(function (data, textStatus) {
            var status = data.status;
            switch (status) {
                case 1:
                    // Pending
                    updateVideoDisplay(videoId, videoStatus.processing);
                    break;
                case 2:
                    // Processed
                    var media_id = data.media_id;
                    updateVideoDisplay(videoId, videoStatus.videoCustom, media_id, 'campaign-video');
                    clearInterval(intervalProcess);
                    break;
                case 3:
                    //Error
                    updateVideoDisplay(videoId, videoStatus.error);
                    clearInterval(intervalProcess);
                    break;
                default:
                // Something went wrong
            }
        });
    }

    M2.CampaignMedia = {
        config: {
            confirmPhotoDeleteTXT: "Are you sure you want to delete this photo?",
            confirmVideoDeleteTXT: "Are you sure you want to delete this video?",
            errorSavingImageText: "There was a problem saving your selfie decoration, please try again."
        },
        init: function () {
            setConfigOptions();
            // Photo Tools
            setInstructions();
            setVideoUploadTools();
        },
        startVideoProcessingCheck: function (videoId) {
            const checkDelay = 10000;
            const processingStatusUrl = document.getElementById(videoId).dataset.statusCheckUrl;
            const playerId = document.getElementById(videoId).dataset.videoPlayerId;
            clearInterval(processingChecks[videoId]);
            processingChecks[videoId] = setInterval(function () {
                checkVideoProcess(videoId);
            }, checkDelay);
        },
        saveVideoStorefrontStatus: function () {
            var storefrontVideoUrl = $("#set-storefront-video-url").val();
            var status = $("#set-storefront-video").is(':checked') ? true : false;
            const token = $("#set-storefront-video").closest("form").find("input[name='__RequestVerificationToken']").val();

            $.ajax({
                url: storefrontVideoUrl,
                type: 'POST',
                data: {
                    use: status,
                    '__RequestVerificationToken': token
                }
            });
        }
    };
})(jQuery);

$(function () {
    M2.CampaignMedia.init();
});